import { ChevronRight } from "lucide-react";
import { Fragment, type ReactNode } from "react";
import { Icon } from "./icon";

export interface Crumb {
  readonly label: string;
  /** The page's address; the last crumb, the current page, has none. */
  readonly href?: string;
}

/** Where a page sits: links to its parents, then the page itself. `renderLink` gives the app's router link. */
export function Breadcrumb({
  label,
  items,
  renderLink = (href, children, className) => (
    <a href={href} className={className}>
      {children}
    </a>
  ),
}: {
  label: string;
  items: readonly Crumb[];
  renderLink?: (href: string, children: ReactNode, className: string) => ReactNode;
}) {
  return (
    <nav aria-label={label}>
      <ol className="flex flex-wrap items-center gap-1.5 text-small text-ink-muted">
        {items.map((item, index) => (
          <Fragment key={`${item.href ?? ""}|${item.label}`}>
            {index > 0 && (
              <li aria-hidden="true" className="flex">
                <Icon icon={ChevronRight} size={16} className="size-3.5" />
              </li>
            )}
            <li className="min-w-0">
              {item.href === undefined ? (
                <span aria-current="page" className="font-medium text-ink tabular-nums">
                  {item.label}
                </span>
              ) : (
                renderLink(item.href, item.label, "hover:text-ink")
              )}
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
}
